// import packags and folders

import Ss2 from './Phy'
import Header from '../../../headfoot/Header'

export default function ClassNotes() {
  return (
    <div>
      <Header />
      <div className="pt-20">
        <Ss2 />
      </div>
    </div>
  )
}
